import { render, staticRenderFns } from "./PaymentMethod.vue?vue&type=template&id=082a3c1e&scoped=true&"
import script from "./PaymentMethod.vue?vue&type=script&lang=ts&scoped=true&"
export * from "./PaymentMethod.vue?vue&type=script&lang=ts&scoped=true&"
import style0 from "./PaymentMethod.vue?vue&type=style&index=0&id=082a3c1e&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082a3c1e",
  null
  
)

export default component.exports